import { lazy } from "react";

export const AppContainer = lazy(() => import("./AppContainer"));
